import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async fetchCardList(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("card/list", data);
    return response;
  },
  async fetchAssignedCardList(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("card/list/assigned", data);
    return response;
  },
  async fetchSchoolAssignedCardList(page, school_id) 
  {
    let data = {
      page: page,
      school_id:school_id
    };
    let response = await apiCall("card/list/assigned", data);
    return response;
  },
  async fetchInactiveCardList(page) 
  {
    let data = {
      page: page,
      status:"2"
    };
    let response = await apiCall("card/list", data);
    return response;
  },
  async fetchUnassignedCardList(page) 
  {
    let data = {
      page: page,
    };
    let response = await apiCall("card/list/unassigned", data);
    return response;
  },

  async fetchLostCardList(page) 
  {
    let data = {
      page: page,
    };
    let response = await apiCall("card/list/lost", data);
    return response;
  },

  async createCard(data) 
  {
    let response = await apiCall("card/add", data);
    return response;
  },

  async turnOnCard(data) 
  {
    let response = await apiCall("card/activate", data);
    return response;
  },

  async turnOffCard(data) 
  {
    let response = await apiCall("card/deactivate", data);
    return response;
  },
  async searchCard(search, page) 
  {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("card/list", data);
    return response;
  },
  async searchUnassignedCard(search, page) 
  {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("card/list/unassigned", data);
    return response;
  },
  async searchAssignedCard(search, page) 
  {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("card/list/assigned", data);
    return response;
  },

  async searchSchoolAssignedCard(search, page, school_id) 
  {
    let data = {
      search: search,
      page: page,
      school_id:school_id
    };
    let response = await apiCall("card/list/assigned", data);
    return response;
  },
  async searchLostCard(search, page) 
  {
    let data = {
      search: search,
      page: page
    };
    let response = await apiCall("card/list/lost", data);
    return response;
  },
  async searchInactiveCard(search, page) 
  {
    let data = {
      search: search,
      page: page,
      status:"2"
    };
    let response = await apiCall("card/list", data);
    return response;
  },
  async attachCard(data) 
  {
    let response = await apiCall("card/attach", data);
    return response;
  },
  async renewCard(data) 
  {
    let response = await apiCall("card/replace", data);
    return response;
  },
  async countAllCards(data) 
  {
    let response = await apiCall("card/count", data);
    return response;
  },
  async countCards() 
  {
    let data = {
      type: "CARD"
    };
    let response = await apiCall("card/count", data);
    return response;
  },
  async countWristbands() 
  {
    let data = {
      type: "WRISTBAND"
    };
    let response = await apiCall("card/count", data);
    return response;
  },
  async countSchoolAssignedCards(school_id) 
  {
    let data = {
      school_id: school_id,
      type: "CARD"
    };
    let response = await apiCall("card/count/assigned", data);
    return response;
  },
  async countSchoolAssignedWristbands(school_id) 
  {
    let data = {
      school_id: school_id,
      type: "WRISTBAND"
    };
    let response = await apiCall("card/count/assigned", data);
    return response;
  },
  async countAssignedCards() 
  {
    let data = {
      type: "CARD",
    };
    let response = await apiCall("card/count/assigned", data);
    return response;
  },
  async countAssignedWristbands() 
  {
    let data = {
      type: "WRISTBAND",
    };
    let response = await apiCall("card/count/assigned", data);
    return response;
  },
  async countInactiveCards(data) 
  {
    let response = await apiCall("card/count/inactive", data);
    return response;
  },
  async countUnassignedCards(data) 
  {
    let response = await apiCall("card/count/unassigned", data);
    return response;
  },
  async updateCard(data) 
  {
    let response = await apiCall("card/update", data);
    return response;
  },
  async markCardAsLost(data) 
  {
    let response = await apiCall("card/mark_as_lost", data);
    return response;
  },

  async listAllCards(data) 
  {
    let response = await apiCall("card/list/all", data);
    return response;
  },
  async deleteCard(data) 
  {
    let response = await apiCall("card/delete", data);
    return response;
  },
  async checkFirstCardAttachment(student_id) 
  {
    let data = {
      student_id:student_id
    };
    let response = await apiCall("card/check_for_first_attachment", data);
    return response;
  },
  async fetchSchoolLostCardList(page, school_id) 
  {
    let data = {
      page: page,
      school_id:school_id
    };
    let response = await apiCall("card/list/lost", data);
    return response;
  },
  async searchSchoolLostCard(search, page, school_id) 
  {
    let data = {
      search: search,
      page: page,
      school_id:school_id
    };
    let response = await apiCall("card/list/lost", data);
    return response;
  },
  async totalCardsAndWristbandsPerSchool(data) {
    let response = await apiCall("card/count/assigned/per_school", data);
    return response;
  },
  async totalCardsAndWristbandsPerClass(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("card/count/assigned/per_class", data);
    return response;
  },
  async emergencyCardUpdate(data) 
  {
    let response = await apiCall("card/replace/emergency", data);
    return response;
  },
  async fetchStudentCardHistory(student_id) 
  {
    let data = {
      page: 1,
      student_id:student_id
    };
    let response = await apiCall("card/list/lost", data);
    return response;
  },
  async fetchActivatedStudentsWithoutCardList(page, school_id) 
  {
    let data = {
      page: page,
      school_id:school_id
    };
    let response = await apiCall("mobile/webapp/activated_students_without_cards", data);
    return response;
  },
  async fetchAllActivatedStudentsWithoutCardList(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/activated_students_without_cards", data);
    return response;
  },
};
